export default "__VITE_ASSET__jDeZ0zYx__"